<div [class.full-background]="!isLeftMenuExpanded" [class.full-background-expanded]="isLeftMenuExpanded">
  <div class="component-container">
    <app-about-page-feedback></app-about-page-feedback>
  </div>
</div>